// src/pages/user/Hotels/GuestProfilesPage.jsx
import React from 'react';

const GuestProfilesPage = () => {
  return (
    <div>
      <h1>Guest Profiles</h1>
      <p>Manage guest profiles here.</p>
    </div>
  );
};

export default GuestProfilesPage;
